module.exports = __webpack_public_path__ + "assets/img/function1.c0c65a6c.png";